import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
// Migrated to Paraglide JS - removed useTranslation
import { chat_newChat, nav_history, nav_settings, actions_close, chat_ai_generating, chat_input_placeholder, newConversation } from '@paraglide/messages';
import { Plus, Sparkles, History, Settings, User, Trash2 } from 'lucide-react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { ThemeProvider } from '@emotion/react';
import { HeroUIProvider } from '@heroui/react';
import { Button } from '@edusense/shared-ui-kit';
import { Tooltip } from '@heroui/react';
import BrandLogo from '../common/BrandLogo';
import ChatContainer from '../chat/ChatContainer';
import ChatInput from '../chat/ChatInput';
import ChatHistoryView from '../history/ChatHistoryView';
import GeneralSettingsView from '../settings/GeneralSettingsView';
import { chatModalTheme } from './ChatModal.styles';
import { CHAT_TEST_IDS } from '@edusense/shared-constants';
const AIChatSidebarView = ({ isMobile, isAutoActivated, isCreatingChat, isGenerating, currentView, currentChatId, messages, onSwitchToUserChat, onClose, setCurrentView, handleCopyMessage, handleSendMessage, handleCreateNewChat, handleClearMessages, stopGeneration })=>{
    // Migrated to Paraglide JS - removed useTranslation
    const [fontSizeValue, setFontSizeValue] = React.useState(()=>{
        const saved = localStorage.getItem('ai-chat-font-size-value');
        return saved ? parseInt(saved) : 14; // 기본값 14px
    });
    // 이전 방식과의 호환성을 위한 fontSize 계산
    const fontSize = fontSizeValue <= 12 ? 'small' : fontSizeValue <= 16 ? 'medium' : 'large';
    const handleFontSizeSliderChange = (value)=>{
        const size = Array.isArray(value) ? value[0] : value;
        setFontSizeValue(size);
        localStorage.setItem('ai-chat-font-size-value', size.toString());
    };
    console.log('[ChatModal] Sidebar mode rendering');
    return /*#__PURE__*/ _jsx(HeroUIProvider, {
        children: /*#__PURE__*/ _jsx(ThemeProvider, {
            theme: chatModalTheme,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "bg-white dark:bg-gray-900 flex flex-col",
                "data-testid": "chatmodal-sidebar",
                style: {
                    height: '100vh',
                    minHeight: '100vh',
                    maxHeight: '100vh',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    margin: 0,
                    padding: 0,
                    border: 'none',
                    outline: 'none',
                    boxSizing: 'border-box',
                    pointerEvents: 'auto',
                    zIndex: 5 // 리사이즈 핸들보다 위에 표시
                },
                ref: (el)=>{
                    if (el) {
                        console.log('[ChatModal] Sidebar element size:', {
                            offsetWidth: el.offsetWidth,
                            offsetHeight: el.offsetHeight,
                            clientWidth: el.clientWidth,
                            clientHeight: el.clientHeight,
                            scrollWidth: el.scrollWidth,
                            scrollHeight: el.scrollHeight
                        });
                    }
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: `flex items-center justify-between ${isMobile ? 'p-2' : 'p-3'} border-b border-gray-200/50 dark:border-gray-800/50 bg-gradient-to-r from-gray-50/30 to-gray-100/20 dark:from-gray-800/30 dark:to-gray-900/20`,
                        style: {
                            flexShrink: 0,
                            flexGrow: 0
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Tooltip, {
                                        content: "AI 튜터입니다. 궁금한 것을 물어보세요.",
                                        placement: "bottom",
                                        delay: 0,
                                        closeDelay: 0,
                                        className: "px-2 py-1 text-xs",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: `${isMobile ? 'p-1.5' : 'p-2'} bg-gradient-to-br from-blue-500 to-purple-600 dark:from-blue-600 dark:to-purple-700 rounded-xl shadow-md shadow-blue-500/20 dark:shadow-blue-500/15 relative overflow-hidden`,
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "absolute inset-0 bg-gradient-to-tr from-white/15 to-transparent"
                                                }),
                                                /*#__PURE__*/ _jsx(BrandLogo, {
                                                    size: "sm",
                                                    className: "text-white relative z-10"
                                                }),
                                                /*#__PURE__*/ _jsx(Sparkles, {
                                                    className: "absolute -top-0.5 -right-0.5 w-2 h-2 text-yellow-300 animate-pulse"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-sm font-medium text-gray-700 dark:text-gray-300",
                                        children: chat_newChat()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center space-x-1",
                                children: [
                                    onSwitchToUserChat && /*#__PURE__*/ _jsx(Tooltip, {
                                        content: "메시지로 전환",
                                        placement: "bottom",
                                        delay: 0,
                                        closeDelay: 0,
                                        className: "px-2 py-1 text-xs",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            iconOnly: true,
                                            icon: /*#__PURE__*/ _jsx(User, {
                                                className: "w-4 h-4"
                                            }),
                                            variant: "ghost",
                                            size: "sm",
                                            onClick: onSwitchToUserChat,
                                            "data-testid": CHAT_TEST_IDS.AI_TO_PEOPLE_SWITCH_BUTTON,
                                            label: "메시지"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Tooltip, {
                                        content: nav_history(),
                                        placement: "bottom",
                                        delay: 0,
                                        closeDelay: 0,
                                        className: "px-2 py-1 text-xs",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            iconOnly: true,
                                            icon: /*#__PURE__*/ _jsx(History, {
                                                className: "w-4 h-4"
                                            }),
                                            variant: "ghost",
                                            size: "sm",
                                            onClick: ()=>setCurrentView('history'),
                                            "data-testid": CHAT_TEST_IDS.HISTORY_VIEW_BUTTON,
                                            label: nav_history()
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Tooltip, {
                                        content: nav_settings(),
                                        placement: "bottom",
                                        delay: 0,
                                        closeDelay: 0,
                                        className: "px-2 py-1 text-xs",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            iconOnly: true,
                                            icon: /*#__PURE__*/ _jsx(Settings, {
                                                className: "w-4 h-4"
                                            }),
                                            variant: "ghost",
                                            size: "sm",
                                            onClick: ()=>{
                                                console.log('[ChatModal] MCP Settings button clicked (sidebar mode)');
                                                setCurrentView('settings');
                                            },
                                            label: nav_settings()
                                        })
                                    }),
                                    !isAutoActivated && /*#__PURE__*/ _jsx(Button, {
                                        iconOnly: true,
                                        icon: /*#__PURE__*/ _jsx(ChevronDownIcon, {
                                            className: "w-4 h-4"
                                        }),
                                        variant: "ghost",
                                        size: "sm",
                                        onClick: onClose,
                                        label: actions_close()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "bg-gradient-to-b from-gray-50/50 to-white dark:from-gray-900/50 dark:to-gray-900",
                        style: {
                            flex: '1 1 auto',
                            minHeight: 0,
                            height: 'auto',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: currentView === 'history' ? /*#__PURE__*/ _jsx(ChatHistoryView, {
                            onBack: ()=>setCurrentView('chat')
                        }) : currentView === 'settings' ? /*#__PURE__*/ _jsx(GeneralSettingsView, {
                            onBack: ()=>setCurrentView('chat')
                        }) : /*#__PURE__*/ _jsx(ChatContainer, {
                            messages: messages,
                            isLoading: isGenerating,
                            onCopy: handleCopyMessage,
                            loadingMessage: chat_ai_generating(),
                            fontSize: fontSize,
                            fontSizeValue: fontSizeValue
                        })
                    }),
                    currentView === 'chat' && /*#__PURE__*/ _jsx("div", {
                        className: `border-t border-gray-200/50 dark:border-gray-800/50 bg-gradient-to-b from-white to-gray-50/50 dark:from-gray-900 dark:to-gray-800/50 ${isMobile ? 'p-2' : 'p-3'}`,
                        style: {
                            flexShrink: 0,
                            flexGrow: 0,
                            position: 'relative',
                            paddingBottom: isMobile ? 'env(safe-area-inset-bottom, 8px)' : undefined,
                            zIndex: 10,
                            pointerEvents: 'auto' // 포인터 이벤트 허용
                        },
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: `${isMobile ? 'space-y-2' : 'space-y-3'}`,
                            children: [
                                /*#__PURE__*/ _jsx(ChatInput, {
                                    onSendMessage: handleSendMessage,
                                    isLoading: isGenerating,
                                    onStopGeneration: stopGeneration,
                                    placeholder: chat_input_placeholder(),
                                    isCompact: true
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-start",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "flex items-center gap-1",
                                        children: currentChatId && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "primary",
                                                    size: "xs",
                                                    leftIcon: /*#__PURE__*/ _jsx(Plus, {
                                                        className: "w-3 h-3"
                                                    }),
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        handleCreateNewChat();
                                                    },
                                                    disabled: isCreatingChat,
                                                    isLoading: isCreatingChat,
                                                    "data-testid": CHAT_TEST_IDS.LIST_NEW_CHAT_BUTTON,
                                                    children: newConversation()
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "ghost",
                                                    size: "xs",
                                                    leftIcon: /*#__PURE__*/ _jsx(Trash2, {
                                                        className: "w-3 h-3"
                                                    }),
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        void handleClearMessages();
                                                    },
                                                    disabled: messages.length === 0 || isGenerating,
                                                    children: '기록 삭제'
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
export default AIChatSidebarView;
